module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAaCAYAAACgoey0AAAACXBIWXMAAAsSAAALEgHS3X78AAABT0lEQVRIie2Wz2qEMBDGExWJgifPQkAQRDz5AqWnHrq3PtA+UG/bQ099AvckIgqCLyAeBA1STUlYJe1u2bZaS8EPgn/Q7+dMnGEgpRSIiuP4XpKkB7CghmF49DzvSXR8B2ZQQsjBNE3A1hIqy5IvhNBOhCuiN4uUATHGi4VrGAY/tm3LsjiBpY8PLhXpNc8z8FrawKuJl1OSJAdCyB1CaKCUql3XAdu2pz/yp6rrGuR5DlRVBRDCjhAiIYSeXdfdwTAMb2RZfnEcB+q6zhFFUfCXfN+fBY6iiH/8WJ5N04Asy2jf97c81RjjCXq6BrIsz8468xB7AmMwFhj3+BJEUZSze9/VJY+RtZXTBt7A/x/8aZfQNA2kaTrLXOyGXwZbljULek1/u8dsClxLI4uluqiq6pWd/8agJ4pBT6yCDwLH4xHrur5fI+imafZBEBRvxP52QnwFidsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seat/seatSale.png
// module id = s8yR
// module chunks = 1